export default __webpack_public_path__ + "static/media/name-page-cover.a639d83b.jpg";